import { getLanguageData } from "../languageData";

export default getLanguageData("en-US");
